import React from 'react'
import Col from 'react-bootstrap/Col'

import Select from '../form/Select'

interface PaginationSelectPropsInterface {
  currentPage?: number | string;
  itemsPerPage: number;
  handlePage: Function;
  totalPages: number;
}

const PaginationSelect = ({
  currentPage,
  itemsPerPage,
  totalPages,
  handlePage,
}: PaginationSelectPropsInterface) => {
  const nbPages = Math.ceil(totalPages / itemsPerPage)
  const pages = []
  for (let page = 1; page <= nbPages; page += 1) {
    pages.push(page)
  }

  return (
    <Col xs={12} className="d-flex justify-content-end mb-3">
      <Select
        controlId="paginationSelect"
        label="Aller à la page"
        classNamesForm="mb-0"
        defaultValue={currentPage || 1}
        onChange={handlePage}
        options={
          pages &&
          pages.map((page, index) => (
            <option key={index} id={page}>
              {page}
            </option>
          ))
        }
      />
    </Col>
  )
}

export default PaginationSelect
